import { Helmet } from "react-helmet-async";
import config from "../config";

export default function SchemaMarkup({ data }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: data.title,
    description: data.description,
    publisher: {
      "@type": "Organization",
      name: config.brandName,
      url: config.siteUrl,
      logo: {
        "@type": "ImageObject",
        url: "/images/logo.png",
      },
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
